import { ref } from 'vue';
import { storeConfig } from '@/shared/storeConfig';

// Páginas de 30 evitam o limit alto (3000) que sobrecarregava os servidores
// da Smartico. O histórico completo é carregado sob demanda via offset.
const PAGE_SIZE = 30;

export const useSmarticoMiniGamesHistory = defineStore(
  'smarticoMiniGamesHistory',
  () => {
    const { debugLog } = useSmarticoConfigs();

    const historyGames = ref<TMiniGameHistoryItem[]>([]);
    const isLoading = ref<boolean>(false);
    const offset = ref<number>(0);
    const hasMore = ref<boolean>(true);

    async function fetchPage(
      currentOffset: number,
    ): Promise<TMiniGameHistoryItem[]> {
      const page = await window._smartico.api.getMiniGamesHistory({
        limit: PAGE_SIZE,
        offset: currentOffset,
      });

      return Array.isArray(page) ? page : [];
    }

    async function loadHistory(): Promise<void> {
      if (isLoading.value) return;

      try {
        isLoading.value = true;

        const firstPage = await fetchPage(0);

        historyGames.value = firstPage;
        offset.value = firstPage.length;
        hasMore.value = firstPage.length === PAGE_SIZE;
      } catch (err: any) {
        debugLog(`⭕️ ~ getPlayedGames ~ ${err.toString()}`);
      } finally {
        isLoading.value = false;
      }
    }

    async function loadMore(): Promise<void> {
      if (isLoading.value || !hasMore.value) return;

      try {
        isLoading.value = true;

        const nextPage = await fetchPage(offset.value);

        historyGames.value = historyGames.value.concat(nextPage);
        offset.value += nextPage.length;
        hasMore.value = nextPage.length === PAGE_SIZE;
      } catch (err: any) {
        debugLog(`⭕️ ~ getPlayedGames ~ ${err.toString()}`);
      } finally {
        isLoading.value = false;
      }
    }

    return {
      historyGames,
      isLoading,
      hasMore,
      loadHistory,
      loadMore,
    };
  },
  storeConfig,
);
